export default {
    data:()=>({
        isLoading: true,
        startDate: new Date(),
        endDate: new Date(),
        listOrderRequestReject: [],
        searchOrderId: '',
        orderRequestId: '',
        filterOrderRequest: {},

        // pagination
        offset: 10,
        pagination: {},
        per_page: 10,
        totalOrder: 0
    }),
    methods: {
        // Fetch Pending Order Request
        FetchRejectOrderRequest(){
            this.isLoading = true;
            this.$axiosDelivery.get('list-reject-order-requests',{
                params:{
                    startDate: this.FormatStartDateAndEndDate(this.startDate),
                    endDate: this.FormatStartDateAndEndDate(this.endDate),
                    page: this.pagination.current_page,
                    per_page: this.per_page
                }
            }).then((res) => {
                setTimeout(()=>{
                    this.listOrderRequestReject = res.data.data;
                    this.pagination = res.data;
                    this.totalOrder = res.data.total;
                    this.isLoading = false;
                }, 300);
            }).catch(()=>{});
        },
        OpenModal_ReasonCancelOrderRequest(orderRequestId){
            this.filterOrderRequest = this.FilterOrderReject(orderRequestId);
            this.$store.commit('modalPreviewFile_State', true);
        },
        OpenModal_RejectOrderRequest(orderRequestId){
            this.orderRequestId = orderRequestId;
            this.$store.commit('modalDelete_State', true);
        },
        FilterOrderReject(orderRequestId){
            return this.listOrderRequestReject.filter(item=>{
                return item.id == orderRequestId;
            })[0] || {};
        },

        EscapeRegExp(string) {
            string = string.toString()
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
        },
    },
    computed:{
        FilterOrderRequestReject(){
			var item = this.EscapeRegExp(this.searchOrderId)
            const pattern = new RegExp(item, 'i')
            return this.listOrderRequestReject.filter(item => {
                setTimeout(()=>{
                    this.isLoading = false;
                }, 300);
                return pattern.test(item.order_id);
            });
        },
    },
    watch:{
        'startDate': function(){
            this.FetchRejectOrderRequest();
        },
        'endDate': function(){
            this.FetchRejectOrderRequest();
        }
    }
}